// 2026-10-08 (Manak, "3a"): the company idle-time value, readable by every profile.
// Was /admin/tenant-config (admin-only → 403 for everyone else → silent 3-minute default).
export const IDLE_THRESHOLD_URL = '/api/v1/employee-attendance/idle-threshold';

/** The company's idle limit in minutes, or null when it cannot be read. */
export async function fetchIdleThresholdMinutes(): Promise<number | null> {
  try {
    const r = await fetch(IDLE_THRESHOLD_URL, { credentials: 'include' });
    if (!r.ok) return null;
    const body = await r.json();
    const mins = body?.data?.activityInactivityMinutes;
    return typeof mins === 'number' && mins > 0 ? mins : null;
  } catch {
    return null;
  }
}
